import {createAction} from '@reduxjs/toolkit';

export const SET_PROJECT_PAYLOAD = 'projects/payload';
export const SET_PRIMARY_CODE = 'projects/payload/primaryCode';
export const LINK_ENGAGEMENT_CODE = 'projects/payload/EngagementCode/Link';
export const UNLINK_ENGAGEMENT_CODE = 'projects/payload/EngagementCode/Unlink';

export const setPrimaryEngagementCodes = createAction(SET_PRIMARY_CODE);

export const linkEngagementCode = createAction(LINK_ENGAGEMENT_CODE);

export const unlinkEngagementCode = createAction(UNLINK_ENGAGEMENT_CODE);

export const setProjectPayload = createAction(SET_PROJECT_PAYLOAD);
